import React from 'react';
import {
  DrawerBody,
  makeStyles,
  OverlayDrawer,
  OverlayDrawerProps,
  shorthands,
  tokens,
} from '@fluentui/react-components';
import { useAppActions, useAppState } from '../context';
import AppContentList from './contentList/contentList';

const useStyles = makeStyles({
  contentList: {
    flexBasis: 'auto',
    minHeight: '10px',
    flexGrow: 0,
    flexShrink: 0,
  },
  contentDrawer: {
    zIndex: 1001,
    position: 'absolute',
    backgroundColor: tokens.colorBrandBackground2,
  },
  contentDrawerBody: {
    overflow: 'hidden',
    height: '100%',
    ...shorthands.padding(0),
  },

  editButton: {
    position: 'absolute',
    right: '0px',
    top: '0px',
    zIndex: 1,
  },
});

export default function AppContentDrawer(props: { mountNode: OverlayDrawerProps['mountNode'] }): JSX.Element {
  const appState = useAppState();
  const appActions = useAppActions();

  const styles = useStyles();

  return (
    <>
      <OverlayDrawer
        modalType="non-modal"
        as="aside"
        className={styles.contentDrawer}
        open={appState.view.contentIsOpen}
        mountNode={props.mountNode}
        onOpenChange={(_, { open }) => (open ? appActions.view.openContent() : appActions.view.closeContent())}
      >
        <DrawerBody className={styles.contentDrawerBody} tabIndex={0}>
          <AppContentList className={styles.contentList} />
        </DrawerBody>
      </OverlayDrawer>
    </>
  );
}
